import { ChangeEvent, SetStateAction } from "react";
import { Option } from "../../../../types/General/Option";
import { AuthUser } from "../../../../types/User/AuthUser";

interface IndicatorSelectComponent {
  fieldNameObject: string;
  options: Option[];
  fieldName: string;
  control: any;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  defaultValue?: string | number | null;
  isRequired: boolean;
  isLoaded: boolean;
}

export const indicatorRegionAnalysisSelectFilterData = (
  levelOptions: Option[],
  provinceOptions: Option[],
  countyOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedLevel: SetStateAction<any>,
  setSelectedProvince: SetStateAction<any>,
  setSelectedCounty: SetStateAction<any>,
  selectedProvince: Option | null,
  indicatorLevel: Option | null,
  levelLoaded: boolean,
  provinceLoaded: boolean,
  countyLoaded: boolean,
  user: AuthUser,
  receivedFilters: any,
): IndicatorSelectComponent[] => {
  const handleLevelChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedLevelId = e.target.value;
    const selected = levelOptions.find(
      (p) => p.id.toString() === selectedLevelId,
    );
    setSelectedLevel(selected || null);
    setFilter("IndicatorLevelId", selectedLevelId);

    setSelectedProvince(null);
    setFilter("ProvinceId", "");

    setSelectedCounty(null);
    setFilter("CountyId", "");
  };

  const handleProvinceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedProvinceId = e.target.value;
    const selected = provinceOptions.find(
      (p) => p.id.toString() === selectedProvinceId,
    );
    setSelectedProvince(selected || null);
    setFilter("ProvinceId", selectedProvinceId);
  };

  const handleCountyChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedCountyId = e.target.value;
    const selected = countyOptions.find(
      (p) => p.id.toString() === selectedCountyId,
    );
    setSelectedCounty(selected || null);
    setFilter("CountyId", selectedCountyId);
  };

  return [
    {
      fieldNameObject: "IndicatorLevelId",
      options: levelOptions,
      fieldName: "Seleccione o nível",
      control: control,
      onChange: handleLevelChange,
      isRequired: true,
      isLoaded: levelLoaded,
      isDisabled: user?.role?.level !== undefined && user.role.level.id >= 4,
      defaultValue:
        receivedFilters?.indicatorLevel?.id ??
        (user?.role?.level?.id === 4 ? 4 : user?.role?.level.id === 5 ? 3 : ""),
    },
    {
      fieldNameObject: "ProvinceId",
      options: provinceOptions,
      fieldName: "Seleccione Província",
      control: control,
      onChange: handleProvinceChange,
      isRequired: true,
      isLoaded: provinceLoaded,
      isDisabled: user?.role?.level !== undefined && user.role.level.id >= 4,
      defaultValue:
        receivedFilters?.province?.id ??
        (user?.role?.level !== undefined && user?.role?.level?.id >= 4
          ? user.province?.id
          : ""),
    },
    {
      fieldNameObject: "CountyId",
      options: countyOptions,
      fieldName: "Seleccione Município",
      control: control,
      onChange: handleCountyChange,
      isDisabled:
        (user?.role?.level !== undefined && user.role.level.id === 5) ||
        !indicatorLevel ||
        indicatorLevel?.id !== 3 ||
        !selectedProvince ||
        selectedProvince.name === "",
      isRequired: indicatorLevel?.id === 3,
      defaultValue:
        receivedFilters?.county?.id ??
        (user?.role?.level !== undefined && user.role.level.id === 5
          ? user.county?.id
          : ""),
      isLoaded: countyLoaded,
    },
  ];
};
